import { FileValidators } from './file-validators';

export const referenceVideoValidator = FileValidators.compose([
  FileValidators.duration({ min: 2, max: 15 }),
  FileValidators.dimensions({ min: 300, max: 6000 }),
  FileValidators.aspectRatio({ min: 0.4, max: 2.5, exclusive: true }),
  FileValidators.pixelCount({ min: 409600, max: 2086876, exclusive: true }),
  FileValidators.excludeCodecs(['av1']),
  FileValidators.frameRate({ min: 23.8, max: 60 }),
]);

export function createUploadValidator(
  options: {
    accept?: string;
  } = {},
) {
  return FileValidators.compose([
    ...(options.accept === undefined
      ? []
      : [FileValidators.accept(options.accept)]),
    FileValidators.whenMime(
      'video/*',
      FileValidators.maxSize(100 * 1000 * 1000, { title: '视频不符合要求' }),
    ),
    FileValidators.whenMime(
      'audio/*',
      FileValidators.duration({ min: 2, max: 15 }, { title: '音频不符合要求' }),
    ),
  ]);
}
